
console.log("starting...");


import "./polyfills.js";
import "./ux/inert.js";

import {report} from "./report.js";
import {gaEvent} from "./util/ga.js";
import * as denylist from "./util/denylist.js";
import {earth} from "./earth.js";
import {
    isAppContext,
    isDevContext,
    isAPIContext,
    isIFrameContext,
    siteInstance,
    siteVersion
} from "./util/context.js";
import {acceptWindowConnection} from "./bridge/comlinkConnector.js";
// require("./clock").calibration({server: "/"}); /*calibration({fixed: "2015-11-24T00:00Z"});*/


/**
 * @param [bridge]
 */
function launch(bridge) {
    try {
        window.earth = earth(bridge);
    } catch (e) {
        report.error(e);
    }
}

void async function main() {

    if (isDevContext()) {
        console.log("dev mode enabled");
    }

    gaEvent("site_instance", siteInstance(), siteVersion());

    // work-around for iOS 10 bug: https://github.com/metafizzy/flickity/issues/457
    window.addEventListener("touchmove", () => {});

    if (isIFrameContext()) {
        gaEvent("iframe", document.referrer.split("/")[2] || document.referrer);
        if (denylist.matches(document.referrer)) {
            denylist.deny();
            return;
        }
    }

    document.getElementById("failure_note").remove();

    if (isAppContext()) {
        window.launch = launch;
        return;
    }

    if (isAPIContext()) {
        const allowedOrigins = new Set([
            "https://earthhq.org",
            "http://localhost:8081",
            "http://localhost:8083",
            "https://localhost:8081",
            "https://staging.earthhq.org",
            "https://gca-earth-hq-test.cube-sites.com",
        ]);
        const bridge = await acceptWindowConnection(allowedOrigins);
        launch(bridge);
        return;
    }

    launch();
}();
